var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 1.4165C4.59427 1.4165 1.41669 4.43542 1.41669 8.14567C1.41669 9.94838 2.18735 11.6785 3.54169 12.9421V16.0203L6.43174 14.576C7.11103 14.7736 7.80585 14.8748 8.50002 14.8748C12.4058 14.8748 15.5834 11.8559 15.5834 8.14567C15.5834 4.43542 12.4058 1.4165 8.50002 1.4165ZM8.50002 2.83317C11.6245 2.83317 14.1667 5.21671 14.1667 8.14567C14.1667 11.0746 11.6245 13.4582 8.50002 13.4582C7.94115 13.4582 7.37779 13.3761 6.82741 13.2161L6.29478 13.0611L5.79812 13.3088L4.95835 13.7293V12.9421V12.3265L4.50734 11.9073C3.44343 10.9142 2.83335 9.54251 2.83335 8.14567C2.83335 5.21671 5.37556 2.83317 8.50002 2.83317Z",
    fill: "#878E95"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.c8bf1c24407eef6637d4d8065ddd8757.svg";
export { ForwardRef as ReactComponent };